import React from 'react'
import Lottie from 'lottie-react';
import { connect } from 'react-redux';
import { animated, useSpring } from '@react-spring/web';
import { getAnnouncementsData, submitViewedAnnouncement } from './State/actions';

import starAnimData from '../../AnimationFiles/star.json';
import starsAnimData from '../../AnimationFiles/stars.json';
import { getEpiData } from '../../Utils/epiHelpers';


const Announcers = (props) => {
    /*
    * TODO as complexity might increase, the animation initialization is not yet looped,
    * could be a bit of a challenge to handle the maintaining of the ref/starting of each lottie component
    * https://react-spring.io/hooks/use-springs
    */

    const stars = props.announcerData.announcements;

    React.useEffect(() => {
        props.loadAnnouncements();
    }, []);

    React.useEffect(() => {
        if (stars.length > 0) {
            setTimeout(() => {
                props.isAnnouncementsViewed();
                dataLayer.push({
                    'event': 'notification_shown',
                    'value': stars
                });
            }, 1000);
        }
    }, [stars]);

    const starAnimRef = React.useRef();

    const starSpring = useSpring({
        config: {
            tension: 120,
            friction: 16,
        },
        /* TODO: refactor into something in the realm of from: "calc(100%+Xpx)" with X being the bottom margin of the card */
        /* probably achievable through view interpolation: https://react-spring.io/basics#view-interpolation */
        from: { translateY: 150 },
        to: [
            { translateY: 0 },
            { translateY: 120, delay: 15000 }
        ],
        delay: 1000,
        onStart: (result, spring) => {
            if ("key" in spring) {
                if (spring.animation.to === 0) {
                    // actual start
                    if (starAnimRef && starAnimRef.current) {
                        starAnimRef.current.play();
                    }
                }
            }
        }
    });

    const url = getEpiData('achievements-list-page-url', props.mountRootId) || '';

    let announcements;
       
    if (stars.length > 0) {
        const multiple = stars.length > 1;
        announcements =
            <animated.div
                style={starSpring} key="star-announcement"
                className="announcement announcement--star">
                <Lottie
                    lottieRef={starAnimRef}
                    className="announcement--animation"
                    animationData={multiple ? starsAnimData : starAnimData}
                    autoplay={false}
                    loop={false}
                />
                <span>Du har fått {multiple ? "nya stjärnor" : "en ny stjärna"}!</span>
            <a href={url}>Visa dina stjärnor</a>
           
            </animated.div>;
    }

    return (
        <React.Fragment>
            <div className="announcement-holder">
                {announcements}               
            </div>         
        </React.Fragment>
    )
}


const mapStateToProps = (state) => {
    return {
        announcerData: state.announcerData
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadAnnouncements: (announcerData) => dispatch(getAnnouncementsData(announcerData)),
        isAnnouncementsViewed: () => dispatch(submitViewedAnnouncement())
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Announcers);